export const CLIENT_DEVICE = Object.create({},{
  COMPUTER:{
    value:'pc',
  },
  MOBILE:{
    value:'mob',
  },
  COMPUTER_WE_CHAT:{
    value:'pcWeChat'
  },
});
const checkDevice = function (device = '') {
  if(!String(device)) return false;
  return [CLIENT_DEVICE.COMPUTER,CLIENT_DEVICE.COMPUTER_WE_CHAT,CLIENT_DEVICE.MOBILE].some(item=>device===item.toString());
}
const host = location.host;
export const chatLogin =({
  client='',
  companyId='',
  companyName='',
  thisUserId='',
  expire=0,
  nonceStr='',
  token='',
  userName='',
})=> {
  if(!checkDevice(client)) return alert('未识别到设备机型，请使用电脑浏览器、手机微信、或者电脑微信登录');
  if(!String(companyId))return alert('未识别公司身份，可能无法聊天，出现此情况请退出账号重新登录即可！');
  if(!String(thisUserId)) return alert('未识别用户身份，可能无法聊天，出现此情况请退出账号重新登录即可！');
  if(!Number(expire)) return alert('登录过期，请刷新页面');
  if(!String(token)) return confirm('进入聊天失败，是否点击刷新重新进入')?location.reload():null;
  return {
    op: "login",
    data: {
      client,
      companyId,
      companyName,
      expire,
      fromUser: thisUserId,
      host,
      nonceStr,
      token,
      userName,
    }
  };
}

export const enterRoom = ({
  client='',
  thisUserId='',
  toRoom='',
  roomUsers=[],
}) =>{
  if(!checkDevice(client)) return alert('未识别到设备机型，请使用电脑浏览器、手机微信、或者电脑微信登录');
  if(!String(thisUserId)) return alert('未识别用户身份，可能无法聊天，出现此情况请退出账号重新登录即可！');
  if(!String(toRoom)) return alert('未获取到发送的房间号，请重新发送！');
  if(!String(roomUsers) || (Array.isArray(roomUsers) && !roomUsers.length) ||(roomUsers instanceof Object && !Object.keys(roomUsers).length)) return alert('此房间没有成员，为无效房间,不能进入');
  if(typeof roomUsers==="string") roomUsers=[roomUsers];
  else if(typeof roomUsers==="number") roomUsers=[String(parseInt(roomUsers))];
  else if(!Array.isArray(roomUsers) && roomUsers instanceof Object) roomUsers = Object.entries(roomUsers).map(item=>item[1]);
  return {
    op: "enterRoom",
    data:{
      client,
      fromUser: thisUserId,
      host,
      room: toRoom,
      roomUsers,
    }
  }
}
export const historyMessage = ({
  fromUser='',
  room='',
  loadedNum=0,
}) =>{
  if(!String(fromUser)) return alert('获取登录身份失败，请重新登录！');
  if(!String(room)) return alert('获取历史记录的房间未找到，请刷新重试！');
  return {
    op:"historyMsg",
    data:{
      host,
      fromUser,
      room,
      loadedNum,//当前展示的消息数目
    }
  }
}

export const sendChat = ({
  fromUser='',
  toUser='',
  room='',
  msg='',
  msgType='',
})=>{
  if(!String(fromUser)) return alert('获取登录身份失败，请重新登录！');
  if(!String(room)) return alert('发送消息的房间未找到，请刷新重试！');
  if(!String(msg)) return alert('不能发送为空的消息');
  if(!String(msgType) ||parseInt(msgType)>5) return alert('未获取到发送消息的类型，无法发送！');
  return {
    op: "send",
    data: {
      host,
      fromUser,
      toUser,/** 开发中，暂时都是公司房间发送（群发）,默认传空，可允许通过 */
      room,
      msg,
      msgType,
    }
  }
}
